// Mock data for Texas Tint Studio

export const services = [
  {
    id: 'automotive',
    title: 'Automotive Window Tinting',
    description: 'Professional car window tinting with premium films for enhanced privacy, comfort, and protection.',
    features: [
      'UV Protection up to 99%',
      'Heat Rejection up to 70%',
      'Glare Reduction',
      'Enhanced Privacy & Security',
      'Scratch Resistant Films',
      'Lifetime Warranty Available'
    ],
    filmOptions: [
      {
        name: 'Ceramic Pro Series',
        description: 'Premium ceramic films with superior heat rejection and clarity',
        tintLevels: ['5%', '15%', '35%', '50%', '70%']
      },
      {
        name: 'Carbon Series',
        description: 'High-quality carbon films with excellent performance and durability',
        tintLevels: ['5%', '15%', '35%', '50%', '70%']
      },
      {
        name: 'Dyed Film Series',
        description: 'Cost-effective option with good heat rejection and privacy',
        tintLevels: ['15%', '35%', '50%', '70%']
      }
    ]
  },
  {
    id: 'residential',
    title: 'Residential Window Tinting',
    description: 'Transform your home with energy-efficient window films that reduce heat, glare, and UV exposure.',
    features: [
      'Energy Cost Reduction up to 30%',
      'UV Protection up to 99%',
      'Fade Protection for Furniture',
      'Improved Comfort & Privacy',
      'Reduced Glare on TVs & Computers',
      'Professional Installation'
    ],
    filmOptions: [
      {
        name: 'Solar Control Films',
        description: 'Maximize energy savings with advanced heat rejection technology',
        benefits: ['Superior heat rejection', 'Maintains natural lighting', 'Reduces cooling costs']
      },
      {
        name: 'Privacy Films',
        description: 'Enhance privacy while maintaining visibility from inside',
        benefits: ['One-way visibility', 'Decorative options available', 'Easy maintenance']
      },
      {
        name: 'Security Films',
        description: 'Added protection against break-ins and severe weather',
        benefits: ['Shatter resistance', 'Enhanced security', 'Storm protection']
      }
    ]
  },
  {
    id: 'commercial',
    title: 'Commercial Window Tinting',
    description: 'Professional window tinting solutions for offices, storefronts, and commercial buildings to improve energy efficiency, comfort, and appearance.',
    features: [
      'Energy Cost Reduction up to 40%',
      'Professional Storefront Appearance',
      'Employee Comfort & Productivity',
      'UV Protection for Merchandise',
      'Enhanced Security & Privacy',
      'Code-Compliant Installation'
    ],
    filmOptions: [
      {
        name: 'Commercial Solar Films',
        description: 'High-performance films designed for large glass surfaces',
        benefits: ['Maximum energy savings', 'Reduced HVAC costs', 'Quick ROI']
      },
      {
        name: 'Decorative & Privacy Films',
        description: 'Frosted, etched, and branded films for professional spaces',
        benefits: ['Conference room privacy', 'Custom branding options', 'Modern aesthetic']
      },
      {
        name: 'Safety & Security Films',
        description: 'Reinforced films that hold glass together on impact',
        benefits: ['Break-in deterrent', 'Storm protection', 'Meets safety codes']
      }
    ]
  }
];

export const reviews = [
  {
    id: 1,
    name: 'Michael Rodriguez',
    rating: 5,
    date: '2024-01-15',
    service: 'Automotive Tinting',
    review: 'Outstanding service from start to finish! The team at Texas Tint Studio did an amazing job on my Toyota Camry. The ceramic tint looks perfect and the heat reduction is incredible. Highly recommend!',
    location: 'Missouri City, TX'
  },
  {
    id: 2,
    name: 'Sarah Johnson',
    rating: 5,
    date: '2024-01-08',
    service: 'Residential Tinting',
    review: 'Had my home windows tinted and couldn\'t be happier with the results. The energy savings are noticeable and the glare reduction makes watching TV much more comfortable. Professional installation and great value.',
    location: 'Stafford, TX'
  },
  {
    id: 3,
    name: 'David Chen',
    rating: 5,
    date: '2023-12-22',
    service: 'Automotive Tinting',
    review: 'Best tint shop in the area! They tinted my BMW and the quality is top-notch. Clean installation, no bubbles, and the customer service was excellent. Worth every penny.',
    location: 'Sugar Land, TX'
  },
  {
    id: 4,
    name: 'Lisa Martinez',
    rating: 5,
    date: '2023-12-18',
    service: 'Residential Tinting',
    review: 'Fantastic experience with Texas Tint Studio. They helped me choose the right films for my home and the installation was flawless. My furniture is protected and my energy bills have decreased significantly.',
    location: 'Richmond, TX'
  },
  {
    id: 5,
    name: 'James Wilson',
    rating: 5,
    date: '2023-12-10',
    service: 'Automotive Tinting',
    review: 'Professional, punctual, and reasonably priced. Had my truck tinted here and the quality exceeded my expectations. The staff explained everything clearly and delivered exactly what they promised.',
    location: 'Rosenberg, TX'
  },
  {
    id: 6,
    name: 'Amanda Thompson',
    rating: 5,
    date: '2023-11-28',
    service: 'Residential Tinting',
    review: 'Excellent work on our home windows. The tint has made a huge difference in comfort and privacy. The technicians were respectful of our home and cleaned up perfectly. Highly satisfied!',
    location: 'Pearland, TX'
  }
];

export const businessInfo = {
  name: 'Texas Tint Studio',
  phone: '(713) 446-8928',
  email: 'info@texastintstudio.com',
  address: {
    street: '6951 McHard Road',
    suite: 'Suite G8',
    city: 'Missouri City',
    state: 'TX',
    zip: '77053'
  },
  hours: {
    weekdays: 'Mon - Fri: 9:00 AM - 6:00 PM',
    saturday: 'Sat: 9:00 AM - 5:00 PM',
    sunday: 'Sun: Closed'
  },
  serviceAreas: [
    'Houston',
    'Missouri City',
    'Sugar Land',
    'Stafford',
    'Richmond',
    'Rosenberg',
    'Pearland',
    'Fort Bend County'
  ]
};
